// ref: https://rangle.gitbook.io/redux-beacon/index/google-tag-manager

/**
  @param type directly pass to GTM -> { event: type } // [UI] something..
  @param extraPayload extra -> { event: type, payload: extraPayload }

  @usage action.hitGTM(UI_NOTIFICATION_PANEL_INFORMATION_MODAL_OPEN)
*/
const hitGTM = (type: string, extraPayload?: {}) => {
  return {
    type,
    payload: extraPayload,
  }
}

export default hitGTM
